import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { IconCaretDown } from "@bynder/icons";
import { token } from "./token.js";
function Arrow(props) {
  return /* @__PURE__ */ jsx(ArrowStyled, {
    ...props,
    children: /* @__PURE__ */ jsx(IconCaretDown, {})
  });
}
const ArrowStyled = styled.div.withConfig({
  displayName: "ArrowStyled",
  componentId: "sc-dmd5wz-0"
})(["margin-right:calc(", " * -1);margin-left:calc(", " * -1);"], token.spacing2, token.spacing2);
export {
  Arrow
};
//# sourceMappingURL=Arrow.js.map
